import {
  EndpointNames,
  Pages,
  RequestMethod
} from '@vio/debug-panel/src/types/enums'
import {ScenarioMetadata} from '@vio/debug-panel/src/types/types'

export const metadata: ScenarioMetadata = {
  scope: 'permanent',
  name: 'Authentication flow on SRP',
  value: 'AuthenticationFlow',
  description: 'Testing different scenarios of authentication flow behavior',
  routes: [
    {
      endpoint: EndpointNames.Offers,
      method: RequestMethod.GET,
      page: Pages.SRP,
      variations: [
        {
          value: 'firstAppLockPreferredRate',
          displayName: 'First offer - APP lock - Preferred rate',
          description:
            'Simulates an App Lock scenario with a preferred rate. The offer in the results should show `Book on Vio app` label.',
          queryParams: {
            utm_source: 'gha'
          }
        },
        {
          value: 'firstAppLockNotPreferredRate',
          displayName: 'First offer - APP lock - Not preferred rate',
          description:
            'Simulates an App Lock scenario with a non-preferred rate. The offer in the results should NOT show the label.'
        },
        {
          value: 'firstSmsLockPreferredRate',
          displayName: 'First offer - Sms lock - Preferred rate',
          description:
            'Simulates an Sms Lock scenario with a preferred rate. Requires user `sign-in`. The offer in the results should show `Unlock with Sms` label.',
          queryParams: {
            utm_source: 'gha'
          }
        },
        {
          value: 'firstSmsLockNotPreferredRate',
          displayName: 'First offer - Sms lock - Not Preferred rate',
          description:
            'Simulates an Sms Lock scenario with a non-preferred rate. The offer in the results should NOT show the label.'
        },
        {
          value: 'firstAuthLockPreferredRate',
          displayName: 'First offer - Auth lock - Preferred rate',
          description:
            'Simulates an Auth Lock scenario with a preferred rate. The offer in the results should show `Sign in to book` label.',
          queryParams: {
            utm_source: 'gha'
          }
        },
        {
          value: 'firstAuthLockNotPreferredRate',
          displayName: 'First offer - Auth lock - Not Preferred rate',
          description:
            'Simulates an Auth Lock scenario with a non-preferred rate. The offer in the results should NOT show the label.'
        },
        {
          value: 'secondaryAppLockPreferredRate',
          displayName: 'Secondary offer - APP lock - Preferred rate',
          description:
            'Simulates an APP Lock scenario with a preferred rate. The secondary offer in the results should show price with a special color.',
          queryParams: {
            utm_source: 'gha'
          }
        },
        {
          value: 'secondaryAppLockNotPreferredRate',
          displayName: 'Secondary offer - APP lock - Not preferred rate',
          description:
            'Simulates an App Lock scenario with a non-preferred rate. The second offer in the results should match the UI of the A-side.'
        },
        {
          value: 'secondarySmsLockPreferredRate',
          displayName: 'Secondary offer - Sms lock - Preferred rate',
          description:
            'Simulates an Sms Lock scenario with a preferred rate. The secondary offer in the results should show price with a special color.',
          queryParams: {
            utm_source: 'gha'
          }
        },
        {
          value: 'secondarySmsLockNotPreferredRate',
          displayName: 'Secondary offer - Sms lock - Not Preferred rate',
          description:
            'Simulates an Sms Lock scenario with a non-preferred rate. The second offer in the results should match the UI of the A-side.'
        },
        {
          value: 'secondaryAuthLockPreferredRate',
          displayName: 'Secondary offer - Auth lock - Preferred rate',
          description:
            'Simulates an Auth Lock scenario with a preferred rate. The secondary offer in the results should show price with a special color.',
          queryParams: {
            utm_source: 'gha'
          }
        },
        {
          value: 'secondaryAuthLockNotPreferredRate',
          displayName: 'Secondary offer - Auth lock - Not Preferred rate',
          description:
            'Simulates an Auth Lock scenario with a non-preferred rate. The second offer in the results should match the UI of the A-side.'
        }
      ]
    }
  ]
}
